import { fetchAsync, postAsync } from 'common/fetch'
import { IEmailRtn } from 'types/Grounding/GroundingRequest'
import { GroundingReturn } from 'types/Grounding/GroundingResult'

export const getGroundingConfigurationByVIN = (vin: string) => {
  return postAsync<GroundingReturn>(`/api/grounding/GetGroundingConfigurationByVIN`, {
    body: vin
  })
}

export const saveGrounding = (req: GroundingReturn) => {
  return postAsync<GroundingReturn>(`/api/grounding/SaveGrounding`, {
    body: req
  })
}

export const checkGroundingService = () => {
  return fetchAsync<boolean>(`/api/grounding/IsServiceRunning`)
}

export const sendEmail = (req: IEmailRtn) => {
  return postAsync<string>(`/api/grounding/SendEmailGroundingPDFByVIN`, {
    body: req
  })
}
